<template>
  <span class="rf-icon" aria-hidden="true">
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <g clip-path="url(#eye-open-icon-a)">
        <g clip-path="url(#eye-open-icon-b)">
          <path
            fill="inherit"
            stroke="none"
            d="M12 10.005a4 4 0 1 1 0 8 4 4 0 0 1 0-8Zm0 1.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5ZM12 6.5c4.613 0 8.596 3.15 9.7 7.564a.75.75 0 0 1-1.454.365 8.504 8.504 0 0 0-16.493.004.75.75 0 0 1-1.456-.363A10.003 10.003 0 0 1 12 6.5Z"
          />
        </g>
      </g>
      <defs>
        <clipPath id="eye-open-icon-a"><path fill="#fff" d="M0 0h24v24H0z" /></clipPath>
        <clipPath id="eye-open-icon-b"><path fill="#fff" d="M0 0h24v24H0z" /></clipPath>
      </defs>
    </svg>
  </span>
</template>
